import type { QuoteDocumentPro } from '@/engines/quote/QuoteTypes'

import type { ClientPdfDocument } from './client-pdf-document'
import { companyFromEmpresa } from './branding-from-empresa'

const dateFormatter = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
})

const CLIENT_BLOCK_TYPES = new Set(['product', 'service', 'labor'])

export function quoteProToClientPdf(doc: QuoteDocumentPro): ClientPdfDocument {
  const items = [...doc.blocks]
    .sort((a, b) => a.position - b.position)
    .filter((block) => CLIENT_BLOCK_TYPES.has(block.type))
    .map((block) => {
      const lineTotal =
        Math.round((block.quantity * block.salePrice - block.discountValue + Number.EPSILON) * 100) /
        100
      return {
        description: block.description,
        quantity: block.quantity,
        unitPrice: block.salePrice,
        lineTotal,
      }
    })

  return {
    number: doc.id.slice(0, 12).toUpperCase(),
    title: doc.title || 'Proposta comercial',
    issuedAtLabel: dateFormatter.format(new Date(doc.updatedAt || doc.createdAt)),
    statusLabel: doc.status,
    company: companyFromEmpresa(),
    client: {
      name: 'Cliente não informado',
    },
    items,
    summary: {
      subtotal: doc.totals.saleTotal,
      discountTotal: doc.totals.discountTotal,
      shipping: 0,
      total: doc.totals.total,
    },
    terms: {},
  }
}
